import { Link } from "react-router-dom"
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

export default function NotFound() {
    return (
        <Box
            id="hero"
            sx={(theme) => ({
                width: '100%',
                backgroundRepeat: 'no-repeat',
                background: 'white'
            })}
        >
            <Container
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    pt: { xs: 14, sm: 18 },
                    pb: { xs: 0, sm: 0 },
                }}
            >
                <h1 className="text-4xl font-bold mb-4">Page Not Found</h1>
                <p className="text-lg mb-8">Sorry, the page you are looking for does not exist.</p>
                <Link to="/" className="text-blue-500 hover:underline">
                    Go back to Home
                </Link>
            </Container>
        </Box>
    )
}